import { ComponentProps } from "react";

interface Props extends ComponentProps<"svg"> {
  width: string;
  height: string;
}

const UkIcon = ({ width, height }: Props) => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_332_215)">
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="#F0F0F0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.609 2.34424C15.8886 2.68916 17.0665 3.28146 18.0885 4.06697L14.609 7.54646V2.34424ZM2.34497 9.39095C2.68985 8.1113 3.28216 6.93337 4.06767 5.91138L7.54724 9.39095H2.34497ZM19.9339 5.91138C20.7193 6.93337 21.3117 8.1113 21.6566 9.39091H16.4544L19.9339 5.91138ZM2.34497 14.6086C2.68989 15.8883 3.2822 17.0662 4.06767 18.0881L7.54712 14.6086H2.34497ZM5.91289 19.9328C6.93488 20.7183 8.11281 21.3106 9.39242 21.6556V16.4534L5.91289 19.9328ZM5.91289 4.06693C6.93484 3.28146 8.11277 2.68916 9.39238 2.34424V7.54643L5.91289 4.06693ZM14.61 21.6556C15.8896 21.3106 17.0675 20.7183 18.0894 19.9329L14.61 16.4534V21.6556ZM19.9339 18.0882L16.4544 14.6086H21.6566C21.3117 15.8883 20.7193 17.0662 19.9339 18.0882Z"
            fill="#0052B4"
          />
          <path
            d="M21.9154 10.6957H13.3044H13.3044V2.08465C12.8774 2.02906 12.4421 2 12 2C11.5579 2 11.1226 2.02906 10.6957 2.08465V10.6956V10.6956H2.08465C2.02906 11.1226 2 11.5579 2 12C2 12.4421 2.02906 12.8774 2.08465 13.3043H10.6956H10.6956V21.9154C11.1226 21.9709 11.5579 22 12 22C12.4421 22 12.8774 21.971 13.3043 21.9154V13.3044V13.3044H21.9154C21.9709 12.8774 22 12.4421 22 12C22 11.5579 21.9709 11.1226 21.9154 10.6957Z"
            fill="#D80027"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.0724 4.92933L14.61 9.39175V8.16198L18.4304 4.34155C18.6527 4.52831 18.8672 4.72409 19.0724 4.92933ZM9.39085 9.39089V9.39086L4.92851 4.92847C4.72328 5.13362 4.5275 5.34812 4.3407 5.57046L8.16113 9.39089H9.39085ZM9.39061 14.6086H9.39069V15.8383L5.57031 19.6588C5.34796 19.472 5.13347 19.2762 4.92831 19.0709L9.39061 14.6086ZM19.0723 19.071L14.61 14.6087V14.6086H15.8398L19.6601 18.429C19.4733 18.6514 19.2776 18.8659 19.0723 19.071Z"
            fill="#D80027"
          />
        </g>
        <defs>
          <clipPath id="clip0_332_215">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default UkIcon;
